// extracted by mini-css-extract-plugin
export default {"actionButtons":"adminTable_actionButtons__mb3jE","closingBalance":"adminTable_closingBalance__4n1zs","alignRight":"adminTable_alignRight__SsV47"};